<template><div><h1 id="eb-kontoauszug" tabindex="-1"><a class="header-anchor" href="#eb-kontoauszug"><span>EB-Kontoauszug</span></a></h1>
<p>EB-Kontoauszug — Die Auswertung listet alle Einzelbuchungen für bestimmte Adressen auf</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung listet alle Einzelbuchungen für bestimmte Personen auf. Einschränkung auf bestimmte Personen-IDs und den Zeitraum. Sortierung nach Personen-ID, Datum aufsteigend, Fakturanummer, Einzelbuchungstyp. Die Auswertung zeigt kumulierte Werte pro Kombination Person / Datum / Fakturanummer / Einzelbuchungstyp.</p>
<p>Wenn zur Person auch ältere Einzelbuchungen existieren als [von Datum], zeigt die Auswertung eine zusätzliche Zeile statt der Fakturanummer mit &quot;vorher&quot; an und den [Saldo]. Wenn auch jüngere Einzelbuchungen als [bis Datum] existieren, zeigt eine separate Zeile statt der Fakturanummer &quot; nachher&quot; an und den [Saldo]. Wenn die Adresse auch Guthaben hat, zeigt eine Zeile statt der Fakturanummer &quot;Guthab.&quot;</p>
<p>Angezeigt werden nur buchhalterisch wirksame Kontobewegungen - das heisst Buchungen wie G, GS, H, HS, K und KS werden nicht gezeigt (diese nur in OP-Buchungen).</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → EB-Kontoauszüge → EB-Kontoauszug</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<ul>
<li>
<p>von Personen-ID:
: ? = von 0 (inklusive)</p>
</li>
<li>
<p>bis:
: ? = bis 99999999 (inklusive)Wenn nur eine einzige Adresse selektiert werden soll: bei von Personen-ID eingeben, bis = ? lassen</p>
</li>
<li>
<p>von Datum:
: leer = unbegrenzt alle alten Daten (sonst: inklusive)</p>
</li>
<li>
<p>bis:
: leer = unbegrenzt bis dato (sonst: inklusive)</p>
</li>
<li>
<p>Adresse anzeigen:
: ja = zeigt die Adresse im Detailnein = zeigt nur Personen-ID</p>
</li>
</ul>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Bildschirm:</td>
<td>ja</td>
</tr>
<tr>
<td>Drucker/Format:</td>
<td>A4 hoch</td>
</tr>
<tr>
<td>Hintergrundverarb.:</td>
<td>ja</td>
</tr>
<tr>
<td>bei Adresse anzeigen ja:</td>
<td>Kurzform der Adresse, die im Anschluss ausgewertet wird.</td>
</tr>
<tr>
<td>Spalten:</td>
<td></td>
</tr>
<tr>
<td>- Adresse:</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>- Datum:</td>
<td>Fakturadatum</td>
</tr>
<tr>
<td>- FaktNum:</td>
<td>Fakturanummer</td>
</tr>
<tr>
<td>- T:</td>
<td>Einzelbuchungstyp</td>
</tr>
<tr>
<td>- Soll:</td>
<td>Fakturabetrag im Soll</td>
</tr>
<tr>
<td>- Haben:</td>
<td>Fakturabetrag im Haben</td>
</tr>
<tr>
<td>- Gutgesch.:</td>
<td>Gutgeschriebener Betrag aus Guthabenkonto</td>
</tr>
<tr>
<td>- Lfd.Saldo:</td>
<td>Saldo per Datum: nur einmal pro Datum angezeigt</td>
</tr>
<tr>
<td>Zeilen:</td>
<td>Zeilen:</td>
</tr>
<tr>
<td>- Total:</td>
<td>Summe der einzelnen Spalten</td>
</tr>
<tr>
<td>- Total:</td>
<td>Gesamttotal des Berichts pro Spalte</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel nur mit Personen-ID</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                                17.02.1999 14:35:53 leh  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                                EB-Kontoauszug</span>
<span class="line">                 von Personen-ID: 1,000      bis: 2,000</span>
<span class="line">                 von Datum.......: 01.01.1998 bis: 31.12.1998</span>
<span class="line"></span>
<span class="line">                 Adresse anzeigen: nein</span>
<span class="line"></span>
<span class="line"> Adresse Datum    FaktNum T          Soll         Haben   Gutgesch.   Lfd.Saldo</span>
<span class="line">-------- -------- ------- --------------- ------------- ----------- -----------</span>
<span class="line">    1004 01.01.98  vorher                                                  0.00</span>
<span class="line">       . 02.03.98  106101 M         50.00</span>
<span class="line">       .        .       . Z                       50.00                    0.00</span>
<span class="line">       . 02.11.98 2112561 A         37.90                                -37.90</span>
<span class="line">       . 06.11.98 2113979 A         54.65                                -92.55</span>
<span class="line">       . 01.12.98 2112561 Z                       37.90</span>
<span class="line">       .        . 2113979 Z                       54.65                    0.00</span>
<span class="line">--------                    ------------- ------------- ----------- -----------</span>
<span class="line">    1004                           142.55        142.55        0.00        0.00 Total</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line">--------                    ------------- ------------- ----------- -----------</span>
<span class="line">    1031                            65.00         65.00        0.00        0.00 Total</span>
<span class="line"></span>
<span class="line">                            ------------- ------------- ----------- -----------</span>
<span class="line">                                98,142.15     97,999.90        0.05     -142.20 Total</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Outputbeispiel mit ganzer Adresse</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                                17.02.1999 14:42:48 leh  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                                EB-Kontoauszug</span>
<span class="line">                 von Personen-ID: 1,000      bis: 2,000</span>
<span class="line">                 von Datum.......: 01.01.1998 bis: 31.12.1998</span>
<span class="line"></span>
<span class="line">                 Adresse anzeigen: ja</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                              Adresse (Kurzform)</span>
<span class="line"> Nr: 1004  Paul Reist                                           Vw.: 31</span>
<span class="line"> Rittergasse 20                             Status: ZSK-   --   Tel:</span>
<span class="line"> 6030 Ebikon                                Geb.J.:             Fax:</span>
<span class="line"></span>
<span class="line"> Adresse Datum    FaktNum T          Soll         Haben   Gutgesch.   Lfd.Saldo</span>
<span class="line">-------- -------- ------- --------------- ------------- ----------- -----------</span>
<span class="line">    1004 01.01.98  vorher                                                  0.00</span>
<span class="line">       . 02.03.98  106101 M         50.00</span>
<span class="line">       .        .       . Z                       50.00                    0.00</span>
<span class="line">       . 02.11.98 2112561 A         37.90                                -37.90</span>
<span class="line">       . 06.11.98 2113979 A         54.65                                -92.55</span>
<span class="line">       . 01.12.98 2112561 Z                       37.90</span>
<span class="line">       .        . 2113979 Z                       54.65                    0.00</span>
<span class="line">--------                    ------------- ------------- ----------- -----------</span>
<span class="line">    1004                           142.55        142.55        0.00        0.00 Total</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line">--------                    ------------- ------------- ----------- -----------</span>
<span class="line">    1982                           100.00        100.00        0.00        0.00 Total</span>
<span class="line"></span>
<span class="line">                            ------------- ------------- ----------- -----------</span>
<span class="line">                                98,142.15     97,999.90        0.05     -142.20 Total</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


